import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 *
 * RAP
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#6674
 **/
const SearchApiService = {
    /**
     * 检查取消登记
     * @param data
     */
    checkCancelRegister(data={}) {
        return request({
            url:  '/service/mg/cancel-register/check',
            method: "POST",
            data
        });
    },
};

export default SearchApiService;
